import { IGetDataProvisaoRecursoDropDownUseCase } from "../../../presentation/useCases/read/get_data_provisao_recurso_drop_down_use_case";
import { DataProvisaoRecursoDropDown } from "../../models/data_provisao_recurso_dropdow";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetDataProvisaoRecursoDropDownUseCase

export class GetDataProvisaoRecursoDropDownUseCase implements IGetDataProvisaoRecursoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getDataProvisaoRecursoDropDown(): Promise<DataProvisaoRecursoDropDown[]> {
    return await this.repository.getDataProvisaoRecursoDropDown();
  }
}
